<template>
  <v-app>
    <NavBar />
    <Loader />
    <ConfirmDialog />
    <Toast />
    <v-main>
      <h1 > {{ $route.name }} </h1>
      <router-view />
      <v-fab-transition>
        <v-btn
          v-scroll="onScroll"
          v-show="fab"
          fab
          dark
          fixed
          bottom
          left
          color="primary"
          @click="toTop"
        >
          <v-icon large>mdi-chevron-up</v-icon>
        </v-btn>
      </v-fab-transition>
    </v-main>
  </v-app>
</template>

<script>
import NavBar from '@/components/NavBar'
import Loader from '@/components/Loader'
import Toast from '@/components/Toast'
import ConfirmDialog from '@/components/ConfirmDialog'
export default {
  name: 'App',
  data() {
    return {
      fab: false
    }
  },
  components: {
    NavBar,
    Loader,
    Toast,
    ConfirmDialog
  },
  methods: {
    onScroll (e) {
      if (typeof window === 'undefined') return
      const top = window.pageYOffset ||   e.target.scrollTop || 0
      this.fab = top > 300
    },
    toTop () {
      this.$vuetify.goTo(0)
    }
  },
};
</script>

<style scoped lang="scss">
  h1 {
    padding: 20px;
    color: $primary-color;
  }
</style>
